export const feedbackReasons = {
  low: [
    ["irrelevant", "추천이 업무와 맞지 않아요"],
    ["misunderstood", "질문 의도를 이해하지 못했어요"],
    ["inaccurate", "답변이 부정확해요"],
    ["unhelpful", "진단이 도움이 되지 않았어요"],
    ["slow", "응답이 느려요"],
  ],
  middle: [
    ["limited", "추천 후보가 아쉬워요"],
    ["detail", "설명이 더 구체적이면 좋겠어요"],
    ["repeated", "반복 질문이 많아요"],
    ["unclear", "다음 단계 안내가 부족해요"],
  ],
  high: [
    ["relevant", "추천이 업무와 잘 맞아요"],
    ["natural", "대화가 자연스러워요"],
    ["clear", "설명이 이해하기 쉬워요"],
    ["helpful", "진단이 도움이 됐어요"],
    ["quick", "응답이 빨라요"],
  ],
} as const;

export const ratingGroup = (rating: number): keyof typeof feedbackReasons =>
  rating <= 2 ? "low" : rating === 3 ? "middle" : "high";
